import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import CollectionsField from '../../form-fields/upload/collections'
import { CreationToolUploadContext } from '../manager'

const Collections = styled(CollectionsField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadCollections = ({ className, field }: Props) => {
    const { setChannelId } = useContext(CreationToolUploadContext)

    return (
        <Collections
            {...{
                className,
                field,
                showInstructions: true,
                onChange: setChannelId,
            }}
        />
    )
}

export default CreationUploadCollections
